<h3>Perfis</h3>
<form [formGroup]="formGroup">
  <div fxLayout="row" fxLayoutAlign="left stretch">
    <div fxLayoutGap="20px">
      <div fxFlex="50">
        <fd-select (loadItemsFn)="getInstitutionList()" [parentForm]="formGroup" [field]="fields.institutionNumber"
          (selectionChange)="selectedInstitution()">
        </fd-select>
      </div>
      <div fxFlex="50">
        <fd-select [parentForm]="formGroup" [field]="fields.serviceContract"
          (selectionChange)="getAllProfilesInstitutionServiceContract()">
        </fd-select>
      </div>
      <div fxFlex="30" fxFlexAlign="center">
        <button *ngIf="hasWriteAccess" class="fd-button" (click)="addProfile()">
          <div class="d-flex  justify-content-center">
            <fa-icon icon='plus-circle' size="1x"></fa-icon> Novo perfil
          </div>
        </button>
      </div>
    </div>
  </div>
</form>

<div class='list'>
  <app-list-profiles [profiles]="profiles" 
    [institutionNumber]="formGroup.value.institutionNumber"
    [serviceContract]="formGroup.value.serviceContract"></app-list-profiles>
</div>
